import { useQuery } from "@tanstack/react-query";
import { getActiveDraft } from "../api/bandDraftApi";
import { ActiveDraft } from "../api/dataTypes";
import { ApiError } from "../api/apiError";

export function useActiveDraft() {
  return useQuery<ActiveDraft, ApiError>({
    queryKey: ["activeDraft"],
    queryFn: getActiveDraft,
    staleTime: 60 * 60 * 1000,
  });
}

export function useCurrentDraft() {
  return useQuery<ActiveDraft, ApiError, Extract<ActiveDraft, { active: true }> | undefined>({
    queryKey: ["activeDraft"],
    queryFn: getActiveDraft,
    staleTime: 60 * 60 * 1000,
    select: (data) => (data.active ? data : undefined),
  });
}
